import { React, models, kea, history, resources, selectores, Route, Router, Switch } from "app/main/std";
import { Header } from "./header";
import { PaginaUruz, Welcome } from "./welcome";
import { Login } from "app/features/general/login/index";
import { IndexCatalogos } from "app/features/general/catalogos/index";
import { NoAutorizado } from "./unauth";
import { MenuOperativa } from "app/features/general/operativa/index";
import { FacturacionOnlineIndex } from "app/features/general/operativa/items/facturaciononline/index";
import { ConfigSistema } from "app/features/general/configuraciones/index";
import { ConfigSistemaLogistica } from "app/features/general/configuraciones logistica/index";

import { NoConfigurado } from "app/features/componentes/configurado";
import { ErrorBoundary } from "./error";
import { RouteComponentProps } from "react-router";


export class InicioGeneral extends React.Component {
    render() {
        return (
            <div>
                <Switch>
                    <Route exact path="/" component={PaginaUruz} />
                    <Route component={Header} />
                </Switch>
                <NoConfigurado />
                <div style={{ paddingTop: "0px", paddingLeft: "20px", paddingRight: "20px" }} >
                    <Route path="/welcome" component={Welcome} />
                    <Route path="/operativa" component={MenuOperativa} />
                    <Route path="/login" component={Login} />
                    <Route path="/facturacion" component={FacturacionOnlineIndex} />
                    <Route path="/catalogos" component={IndexCatalogos} />
                    <Route path="/configuracion" component={ConfigSistema} />
                    <Route path="/noautorizado" component={NoAutorizado} />
                    <Route path="/configuracionLogistica" component={ConfigSistemaLogistica} />
                </div>
            </div>
        )
    }
}





// WEBPACK FOOTER //
// ./app/features/inicio/index.tsx